import { EntityDetail } from "@/components/finance/EntityDetail";
import { INVESTMENT_FIELDS, INVESTMENT_MOVES, money } from "@/lib/finance";

const Stat = ({ label, value, testid }) => (
  <div>
    <p className="text-[11px] opacity-70">{label}</p>
    <p data-testid={testid} className="font-mono text-sm font-bold tabular-nums">{value}</p>
  </div>
);

const Summary = ({ item }) => {
  const s = item.stats;
  const c = item.currency;
  return (
    <div data-testid="investment-summary" className="rounded-2xl p-4 bg-[#0b2a47] text-white grid grid-cols-2 gap-3">
      <Stat label="Comprometido" value={money(item.committed_amount, c)} testid="summary-committed" />
      <Stat label="Aportado" value={money(s.contributed, c)} testid="summary-contributed" />
      <Stat label="Retornos" value={money(s.returns, c)} testid="summary-returns" />
      <Stat label="Por aportar" value={money(s.pending_to_contribute, c)} testid="summary-pending" />
      {s.withdrawals > 0 && <Stat label="Retiros" value={money(s.withdrawals, c)} testid="summary-withdrawals" />}
      {s.last_valuation && <Stat label="Última valuación" value={money(s.last_valuation.amount, c)} testid="summary-valuation" />}
    </div>
  );
};

export default function InvestmentDetailPage() {
  return <EntityDetail endpoint="/investments" backTo="/inversiones" eyebrow="Inversión" titleKey="name" fields={INVESTMENT_FIELDS} moveTypes={INVESTMENT_MOVES} Summary={Summary} />;
}
